export const SIGN_UP_FORM_INITIAL_VALUES = {
  email: "",
  firstname: "",
  lastname: "",
  phone: "",
  password: "",
  passwordRepeat: "",
};

export const SIGN_UP_INPUTS = ["firstname", "lastname", "phone"];
